'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopRegisterComponent = function (_Component) {
  (0, _inherits3.default)(ExperienceShopRegisterComponent, _Component);

  function ExperienceShopRegisterComponent() {
    (0, _classCallCheck3.default)(this, ExperienceShopRegisterComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopRegisterComponent).apply(this, arguments));
  }

  (0, _createClass3.default)(ExperienceShopRegisterComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./Login.scss');

      return _react2.default.createElement(
        'form',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.loginMes, style: { width: '100%', height: 'auto' } },
          _react2.default.createElement(
            'div',
            { className: styles.loginH1 },
            '体验店注册'
          ),
          _react2.default.createElement('img', { className: styles.registerImg,
            src: 'http://tupian.goeasy.cn:9999/yipinwang/experienceShopRegisterQRCode.png' })
        )
      );
    }
  }]);
  return ExperienceShopRegisterComponent;
}(_react.Component); /**
                      * Created by zfc on 2017/7/15.
                      */

exports.default = ExperienceShopRegisterComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Login/ExperienceShopRegisterComponent.js
 ** module id = 1367
 ** module chunks = 0
 **/